export default "/images/vendor/flag-icons/flags/4x3/je.svg?094e9043efbacd7f32c1268a45d1bdb3";